import {StateRegion} from './model/state-region';
import { SalaryMultiples } from './model/salary-multiples';
import { PrismDropDown } from './model/prism-dropdown';
import { DropDown } from './model/drop-down';
import { ApplicantType } from './model/ui/applicant-type';
import { IdleTimeoutConfiguration } from './model/idle-timeout-configuration';

export enum EEOI_APP_ROUTES {
  INSTRUCTIONS = '/instructions',
  STATE_OF_RESIDENCE = '/state-of-residence',
  STATE_TERMS = '/state-terms',
  ESIGN_DISCLOSURE = '/esign-disclosure',
  POLICY = '/policy',
  APPLICANT_TYPE = '/applicant-type',
  COVERAGE = '/coverage',
  MHS = '/mhs',
  EMPLOYEE_INFO = '/employee-information',
  APPLICANT_INFO = '/applicant-information',
  MEDICAL_HISTORY = '/medical-history',
  PHYSICIAN_INFO = '/physician-information',
  AUTHORIZATION = '/authorization',
  ELECTRONIC_COMMUNICATION = '/electronic-communication',
  AUTH_ELEC_SIGN = '/review',
  CONFIRMATION = '/confirmation',
  CONTACT_US = '/contact-us',
  PAGE_NOT_FOUND = 'page-not-found',
  INVALID_POLICY_NUMBER = 'invalid-policy-number',
}

export enum DRUPAL_ENVIRONMENT_MAPPING {
  prod ='sfg',
  playground = 'int',
  dev ='sys',
  nonprod ='acc'
};

export enum COMPANY_ID {
  NM = "NM",
  SI = "SI",
  YI = "YI"
}

export enum COMPANY_DATA_THEME {
  NM = "nwm",
  SFG = "standard"
}

export enum COUNTRIES {
  US = "US"
}

export enum SECTION_ID {
  //WIZARD_DATA = 'wizardData',
  EMPLOYEE_INFO = 'employee',
  APPLICANT_INFO = 'applicant',
  PHYSICIAN_INFO = 'physician',
  MEDICAL_HISTORY = 'medicalHistory',
  AUTH_SIGN = 'authSign'
}

/**
 * idleSeconds is the amount of seconds before the timeout should occur.
 * warningSeconds is the amount of seconds before the timeout that the warning box should appear.
 */
 export const EOI_IDLE_TIMEOUT_CONFIG: IdleTimeoutConfiguration = {
  idleSeconds: 1800, // 30 minutes
  warningSeconds: 120, // 2 minutes prior (warning will appear after 28 minutes)
  showLogoutAction: true
}

// Test config
// export const EOI_IDLE_TIMEOUT_CONFIG: IdleTimeoutConfiguration = {
//   idleSeconds: 20, // 20 seconds
//   warningSeconds: 10, // 10 seconds
//   showLogoutAction: false
// }

export class GlobalConstants {

  public static readonly nwmLogoMobile: string = "assets/images/nwm-brandmark-mobile.svg";
  public static readonly nwmLogoDesktop: string = "assets/images/nwm-brandmark-desktop.svg";
  public static readonly nwmUrl: string = "https://www.northwesternmutual.com";
  public static readonly sicLogoMobile: string = "assets/images/standardLogo.svg";
  public static readonly sicLogoDesktop: string = "assets/images/standardLogo.svg";
  public static readonly sicUrl: string = "https://www.standard.com";
  public static readonly maintenanceLogo: string = "assets/images/Sick-Computer-New.svg";
  public static readonly alertLogo: string = "assets/images/Alert.svg";
  public static readonly maintenanceKey: string = "OEOI_DOWN_MAINTENANCE";
  public static readonly enableSnyKey: string = "ENABLE_SNY";

  public static readonly CARRIER_NAME_SFG: string = 'StanCorp Financial Group, Inc.';
  public static readonly CARRIER_NAME_NM: string = 'The Northwestern Mutual Life Insurance Company';
  public static readonly CARRIER_NAME_SNY: string = 'The Standard Life Insurance Company of New York. 445 Hamilton Avenue, 11th Floor, White Plains, NY 10601.';

  public static readonly LEGAL_URL_SFG = 'https://www.standard.com/legal-privacy';
  public static readonly LEGAL_URL_NM = 'https://www.northwesternmutual.com/legal-information/';

  public static readonly CUSTOM_URL_PARAM_NAME: string = 'policyId';
    public static readonly CEOI_POLICY_FLAG: string = 'ceoiPolicyFlag';
  public static readonly API_SUBSCRIPTION_PARAM_NAME: string = 'subscription-key';
  public static readonly DEFAULT_TIMEOUT = 30000;
  public static readonly MASTER_CONTROL_POLICY = 'MASTER_CONTROL_POLICY';

  // Patterns for Input Field Validation
  public static readonly SSN_VALIDATOR_PATTERN = '^\[\*\u20220-9\]{3} ?\[\*\u20220-9\]{2} ?\[\*\u20220-9\]{2}\\d{2}$';
  public static readonly ACTUAL_SSN_VALIDATOR_PATTERN = '^(?!000000000)(?!000|666|9\\d{2})\\d{3}(?!00)\\d{2}(?!0000)\\d{4}$';
  public static readonly POSTAL_CODE_PATTERN_US = '^(?!00000)(?!000000000)\\d{5}(\\d{4}){0,1}';
  public static readonly POSTAL_CODE_PATTERN_NON_US = '^[A-Za-z0-9][A-Za-z0-9 -]{0,10}[A-Za-z0-9]$';
  public static readonly POSTAL_CODE_PATTERN_CANADA = '(?!.*[DdFfIiOoQqUu])[A-Va-vXxYy][0-9][a-zA-Z]\\s?[0-9][a-zA-Z][0-9]';
  public static readonly POSTAL_CODE_DEBOUNCE_TIME = 250;
  public static readonly NUMBER_PATTERN = "[0-9]+";
  // Keep separators explicit to avoid catastrophic backtracking on repeated invalid input.
  public static readonly NAME_PATTERN = "^[A-Za-zÀ-ÖØ-öø-ÿÑñÁÉÍÓÚÜáéíóúü]+(?:(?:[.'\-] ?| )[A-Za-zÀ-ÖØ-öø-ÿÑñÁÉÍÓÚÜáéíóúü]+)*$";

  public static readonly REASON_LAST_CONSULTED_PATTERN = "^([A-Za-zÀ-ÖØ-öø-ÿÑñÁÉÍÓÚÜáéíóúü0-9,; '\\\"?!&\"])*$";
  public static readonly ADDRESS_PATTERN = "^[#.0-9A-Za-zÀ-ÖØ-öø-ÿÑñÁÉÍÓÚÜáéíóúü'., \-/\\\\]+$";

  // Mask Patterns for Input Field MASKS
  public static readonly ZIP_CODE_MASK = '00000-9999';
  public static readonly ZIP_CODE_MASK_CANADA = 'C0C 0C0';

  public static readonly PHONE_MASK = '(000) 000-0000';
  public static readonly PHONE_MASK_NON_US = '0000000000';
  public static readonly PHONE_MAX_LENGTH_US = 14;
  public static readonly PHONE_MAX_LENGTH_NON_US = 10;
  public static readonly PHONE_REGEX = '^[2-9][0-9]{2}[2-9][0-9]{2}[0-9]{4}$';
  public static readonly IDI_POLICY_NUM_PATTERN = '^((NYC[TN])|(XB0)|(00[CGHMJP]+))[a-zA-Z0-9]+$';
  public static readonly CANADA_SOCIAL_SECURITY_PATTERN = 'A{20}';

  public static readonly SOCIAL_SECURITY_PATTERN = 'AAA - AA - 0000';

  public static readonly MAX_LENGTH_NAME = 50;
  public static readonly MAX_LENGTH_EMPLOYER = 150;
  public static readonly MAX_LENGTH_OCCUPATION = 40;
  public static readonly MAX_LENGTH_LINE1 = 64;
  public static readonly MAX_LENGTH_CITY = 40;
  public static readonly MAX_LENGTH_STATE = 40;
  public static readonly MAX_LENGTH_STATE_CD = 2;
  public static readonly MAX_LENGTH_ZIP = 5;
  public static readonly MAX_LENGTH_ZIP_NON_US = 10;
  public static readonly MAX_LENGTH_EMAIL = 50;
  public static readonly MAX_LENGTH_SALARY = 13;    // 9 digits + 2 commas
  public static readonly MAX_LENGTH_AMOUNT = 13;    // 9 digits + 2 commas
  public static readonly MAX_DATE = "12/31/9999";
  public static readonly MONTH_PICKER_MIN_DATE_YEAR_OFFSET = -100;
  public static readonly DATE_PICKER_BIRTH_DATE_RANGE_START_YEAR_OFFSET = 47; //Please check Voyager-1825 to understand the addition of this constant
  public static readonly MONTH_PICKER_MIN_DATE_MONTH_OFFSET = 0;
  public static readonly MAX_DATE_OFFSET_CLEAR = "CLEAR";
  public static readonly MONTH_PICKER_MIN_DATE_DAY_OFFSET = 1;
  public static readonly ADD_MONTH_IN_DATE = 4;
  public static readonly MIN_AGE = 15;
  public static readonly MAX_LENGTH_MONTH_PICKER = 7;
  public static readonly MAX_LENGTH_HW_FEET = 1;
  public static readonly MAX_LENGTH_HW_INCHES = 2;
  public static readonly MAX_LENGTH_HW_WEIGHT = 3;
  public static readonly MAX_LENGTH_GENERIC_INPUT = 50;
  public static readonly MAX_LENGTH_GENERIC_TREATMENT = 270;
  public static readonly MAX_LENGTH_PHYSICIAN_FIRSTNAME = 50;
  public static readonly MAX_LENGTH_PHYSICIAN_ADDRESS = 70;

  // eslint-disable-next-line
  public static DATE_TIME_FORMAT_STRING = `yyyy-MM-dd'T'00:00:00`;
  /** 
   * Email pattern: based on the requested pattern but extended to include spanish letters
   * Local part allows A-Z, 0-9, punctuation and extended Latin letters
   * Domain labels allow letters/digits and hyphens, require at least one dot
   * Final TLD must be at least 2 characters and may include extended spanish letters
   * Disallow the literal TLD 'con' (case-insensitive) via negative lookahead as in the original
  */
  public static readonly EMAIL_PATTERN = "^([A-Za-zÀ-ÖØ-öø-ÿÑñÁÉÍÓÚÜáéíóúü0-9.!#$%&'+/=?_`{|}~\\-]+@(?:[A-Za-zÀ-ÖØ-öø-ÿÑñÁÉÍÓÚÜáéíóúü0-9](?:[A-Za-zÀ-ÖØ-öø-ÿÑñÁÉÍÓÚÜáéíóúü0-9\\-]{0,61}[A-Za-zÀ-ÖØ-öø-ÿÑñÁÉÍÓÚÜáéíóúü0-9])?\\.)+(?!con$|CON$)[A-Za-zÀ-ÖØ-öø-ÿÑñÁÉÍÓÚÜáéíóúü]{2,})$";
  public static readonly DATE_FORMAT_STRING = 'yyyy-MM-dd';
  public static readonly DATE_FORMAT_STRING_READABLE = 'M/d/yyyy';
  public static readonly DATE_FORMAT_LOCALE = 'en-US'
  public static readonly DATE_PATTERN_REGEX = '^\\d{2}/\\d{2}/\\d{4}$'; //'mm-dd-yyy'

  public static readonly MONTH_DATE_FORMAT_STRING = 'MM/yyyy';
  public static readonly YEAR_MONTH_DATE_FORMAT_STRING = 'yyyy-MM';

  public static BIRTH_PLACE_US = 'US';
  public static BIRTH_PLACE_OUTSIDE_THE_US = 'NON-US';

  public static readonly CANADIAN_PROVINCES: Array<StateRegion> = [
    { abbreviation: 'AB', label: 'Alberta' },
    { abbreviation: 'BC', label: 'British Columbia' },
    { abbreviation: 'LB', label: 'Labrador' },
    { abbreviation: 'MB', label: 'Manitoba' },
    { abbreviation: 'NB', label: 'New Brunswick' },
    { abbreviation: 'NF', label: 'Newfoundland' },
    { abbreviation: 'NT', label: 'Northwest Territories' },
    { abbreviation: 'NS', label: 'Nova Scotia' },
    { abbreviation: 'NU', label: 'Nunavut' },
    { abbreviation: 'ON', label: 'Ontario' },
    { abbreviation: 'PE', label: 'Prince Edward Island' },
    { abbreviation: 'PQ', label: 'Quebec' },
    { abbreviation: 'SK', label: 'Saskatchewan' },
    { abbreviation: 'YK', label: 'Yukon Territories' }
  ];

  public static US_STATES: Array<StateRegion> = [
    { abbreviation: 'AL', label: 'Alabama' },
    { abbreviation: 'AK', label: 'Alaska' },
    { abbreviation: 'AS', label: 'American Samoa' },
    { abbreviation: 'AZ', label: 'Arizona' },
    { abbreviation: 'AR', label: 'Arkansas' },
    //{ abbreviation: 'AA', label: 'Armed Forces Americas (excluding Canada)' },
    //{ abbreviation: 'AE', label: 'Armed Forces Europe,Middle East,Africa,Canada' },
    //{ abbreviation: 'AP', label: 'Armed Forces Pacific' },
    { abbreviation: 'CA', label: 'California' },
    //{ abbreviation: 'CN', label: 'Central' },
    { abbreviation: 'CO', label: 'Colorado' },
    { abbreviation: 'CT', label: 'Connecticut' },
    { abbreviation: 'DE', label: 'Delaware' },
    { abbreviation: 'DC', label: 'District of Columbia' },
    //{ abbreviation: 'FM', label: 'Federated States of Micronesia' },
    { abbreviation: 'FL', label: 'Florida' },
    { abbreviation: 'GA', label: 'Georgia' },
    { abbreviation: 'GU', label: 'Guam' },
    { abbreviation: 'HI', label: 'Hawaii' },
    { abbreviation: 'ID', label: 'Idaho' },
    { abbreviation: 'IL', label: 'Illinois' },
    { abbreviation: 'IN', label: 'Indiana' },
    { abbreviation: 'IA', label: 'Iowa' },
    { abbreviation: 'KS', label: 'Kansas' },
    { abbreviation: 'KY', label: 'Kentucky' },
    { abbreviation: 'LA', label: 'Louisiana' },
    { abbreviation: 'ME', label: 'Maine' },
    //{ abbreviation: 'MH', label: 'Marshall Islands' },
    { abbreviation: 'MD', label: 'Maryland' },
    { abbreviation: 'MA', label: 'Massachusetts' },
    { abbreviation: 'MI', label: 'Michigan' },
    { abbreviation: 'MN', label: 'Minnesota' },
    { abbreviation: 'MS', label: 'Mississippi' },
    { abbreviation: 'MO', label: 'Missouri' },
    { abbreviation: 'MT', label: 'Montana' },
    { abbreviation: 'NE', label: 'Nebraska' },
    { abbreviation: 'NV', label: 'Nevada' },
    { abbreviation: 'NH', label: 'New Hampshire' },
    { abbreviation: 'NJ', label: 'New Jersey' },
    { abbreviation: 'NM', label: 'New Mexico' },
    { abbreviation: 'NY', label: 'New York' },
    { abbreviation: 'NC', label: 'North Carolina' },
    { abbreviation: 'ND', label: 'North Dakota' },
    //{ abbreviation: 'EN', label: 'Northeastern' },
    { abbreviation: 'MP', label: 'Northern Mariana Islands' },
    { abbreviation: 'OH', label: 'Ohio' },
    { abbreviation: 'OK', label: 'Oklahoma' },
    { abbreviation: 'OR', label: 'Oregon' },
    //{ abbreviation: 'PW', label: 'Palau' },
    { abbreviation: 'PA', label: 'Pennsylvania' },
    { abbreviation: 'PR', label: 'Puerto Rico' },
    { abbreviation: 'RI', label: 'Rhode Island' },
    { abbreviation: 'SC', label: 'South Carolina' },
    { abbreviation: 'SD', label: 'South Dakota' },
    //{ abbreviation: 'SE', label: 'Southeastern' },
    { abbreviation: 'TN', label: 'Tennessee' },
    { abbreviation: 'TX', label: 'Texas' },
    { abbreviation: 'UT', label: 'Utah' },
    { abbreviation: 'VT', label: 'Vermont' },
    { abbreviation: 'VI', label: 'Virgin Islands, U.S.' },
    { abbreviation: 'VA', label: 'Virginia' },
    { abbreviation: 'WA', label: 'Washington' },
    { abbreviation: 'WV', label: 'West Virginia' },
    //{ abbreviation: 'WS', label: 'Western' },
    { abbreviation: 'WI', label: 'Wisconsin' },
    { abbreviation: 'WY', label: 'Wyoming' }
  ];

  public static US_STATES_NM: Array<StateRegion> = [
    { abbreviation: 'AL', label: 'Alabama' },
    { abbreviation: 'AK', label: 'Alaska' },
    { abbreviation: 'AZ', label: 'Arizona' },
    { abbreviation: 'AR', label: 'Arkansas' },
    { abbreviation: 'CA', label: 'California' },
    { abbreviation: 'CO', label: 'Colorado' },
    { abbreviation: 'CT', label: 'Connecticut' },
    { abbreviation: 'DC', label: 'District of Columbia' },
    { abbreviation: 'DE', label: 'Delaware' },
    { abbreviation: 'FL', label: 'Florida' },
    { abbreviation: 'GA', label: 'Georgia' },
    { abbreviation: 'HI', label: 'Hawaii' },
    { abbreviation: 'ID', label: 'Idaho' },
    { abbreviation: 'IL', label: 'Illinois' },
    { abbreviation: 'IN', label: 'Indiana' },
    { abbreviation: 'IA', label: 'Iowa' },
    { abbreviation: 'KS', label: 'Kansas' },
    { abbreviation: 'KY', label: 'Kentucky' },
    { abbreviation: 'LA', label: 'Louisiana' },
    { abbreviation: 'MA', label: 'Massachusetts' },
    { abbreviation: 'ME', label: 'Maine' },
    { abbreviation: 'MD', label: 'Maryland' },
    { abbreviation: 'MI', label: 'Michigan' },
    { abbreviation: 'MN', label: 'Minnesota' },
    { abbreviation: 'MS', label: 'Mississippi' },
    { abbreviation: 'MO', label: 'Missouri' },
    { abbreviation: 'MT', label: 'Montana' },
    { abbreviation: 'NE', label: 'Nebraska' },
    { abbreviation: 'NV', label: 'Nevada' },
    { abbreviation: 'NH', label: 'New Hampshire' },
    { abbreviation: 'NJ', label: 'New Jersey' },
    { abbreviation: 'NM', label: 'New Mexico' },
    { abbreviation: 'NY', label: 'New York'},
    { abbreviation: 'NC', label: 'North Carolina' },
    { abbreviation: 'ND', label: 'North Dakota' },
    { abbreviation: 'OH', label: 'Ohio' },
    { abbreviation: 'OK', label: 'Oklahoma' },
    { abbreviation: 'OR', label: 'Oregon' },
    { abbreviation: 'PA', label: 'Pennsylvania' },
    { abbreviation: 'RI', label: 'Rhode Island' },
    { abbreviation: 'SC', label: 'South Carolina' },
    { abbreviation: 'SD', label: 'South Dakota' },
    { abbreviation: 'TN', label: 'Tennessee' },
    { abbreviation: 'TX', label: 'Texas' },
    { abbreviation: 'UT', label: 'Utah' },
    { abbreviation: 'VT', label: 'Vermont' },
    { abbreviation: 'VA', label: 'Virginia' },
    { abbreviation: 'WA', label: 'Washington' },
    { abbreviation: 'WV', label: 'West Virginia' },
    { abbreviation: 'WI', label: 'Wisconsin' },
    { abbreviation: 'WY', label: 'Wyoming' }
  ];

  public static US_STATE_OF_RESIDENCE: Array<StateRegion> = [
    { abbreviation: 'AL', label: 'Alabama' },
    { abbreviation: 'AK', label: 'Alaska' },
    { abbreviation: 'AS', label: 'American Samoa' },
    { abbreviation: 'AZ', label: 'Arizona' },
    { abbreviation: 'AR', label: 'Arkansas' },
    //{ abbreviation: 'AA', label: 'Armed Forces Americas (excluding Canada)' },
    //{ abbreviation: 'AE', label: 'Armed Forces Europe,Middle East,Africa,Canada' },
    //{ abbreviation: 'AP', label: 'Armed Forces Pacific' },
    { abbreviation: 'CA', label: 'California' },
    //{ abbreviation: 'CN', label: 'Central' },
    { abbreviation: 'CO', label: 'Colorado' },
    { abbreviation: 'CT', label: 'Connecticut' },
    { abbreviation: 'DE', label: 'Delaware' },
    { abbreviation: 'DC', label: 'District of Columbia' },
    //{ abbreviation: 'FM', label: 'Federated States of Micronesia' },
    { abbreviation: 'FL', label: 'Florida' },
    { abbreviation: 'GA', label: 'Georgia' },
    { abbreviation: 'GU', label: 'Guam' },
    { abbreviation: 'HI', label: 'Hawaii' },
    { abbreviation: 'ID', label: 'Idaho' },
    { abbreviation: 'IL', label: 'Illinois' },
    { abbreviation: 'IN', label: 'Indiana' },
    { abbreviation: 'IA', label: 'Iowa' },
    { abbreviation: 'KS', label: 'Kansas' },
    { abbreviation: 'KY', label: 'Kentucky' },
    { abbreviation: 'LA', label: 'Louisiana' },
    { abbreviation: 'ME', label: 'Maine' },
    //{ abbreviation: 'MH', label: 'Marshall Islands' },
    { abbreviation: 'MD', label: 'Maryland' },
    { abbreviation: 'MA', label: 'Massachusetts' },
    { abbreviation: 'MI', label: 'Michigan' },
    { abbreviation: 'MN', label: 'Minnesota' },
    { abbreviation: 'MS', label: 'Mississippi' },
    { abbreviation: 'MO', label: 'Missouri' },
    { abbreviation: 'MT', label: 'Montana' },
    { abbreviation: 'NE', label: 'Nebraska' },
    { abbreviation: 'NV', label: 'Nevada' },
    { abbreviation: 'NH', label: 'New Hampshire' },
    { abbreviation: 'NJ', label: 'New Jersey' },
    { abbreviation: 'NM', label: 'New Mexico' },
    { abbreviation: 'NY', label: 'New York' },
    { abbreviation: 'NC', label: 'North Carolina' },
    { abbreviation: 'ND', label: 'North Dakota' },
    //{ abbreviation: 'EN', label: 'Northeastern' },
    { abbreviation: 'MP', label: 'Northern Mariana Islands' },
    { abbreviation: 'OH', label: 'Ohio' },
    { abbreviation: 'OK', label: 'Oklahoma' },
    { abbreviation: 'OR', label: 'Oregon' },
    { abbreviation: 'OT', label: 'OTHER' },
    //{ abbreviation: 'PW', label: 'Palau' },
    { abbreviation: 'PA', label: 'Pennsylvania' },
    { abbreviation: 'PR', label: 'Puerto Rico' },
    { abbreviation: 'RI', label: 'Rhode Island' },
    { abbreviation: 'SC', label: 'South Carolina' },
    { abbreviation: 'SD', label: 'South Dakota' },
    //{ abbreviation: 'SE', label: 'Southeastern' },
    { abbreviation: 'TN', label: 'Tennessee' },
    { abbreviation: 'TX', label: 'Texas' },
    { abbreviation: 'UT', label: 'Utah' },
    { abbreviation: 'VT', label: 'Vermont' },
    { abbreviation: 'VI', label: 'Virgin Islands, U.S.' },
    { abbreviation: 'VA', label: 'Virginia' },
    { abbreviation: 'WA', label: 'Washington' },
    { abbreviation: 'WV', label: 'West Virginia' },
    //{ abbreviation: 'WS', label: 'Western' },
    { abbreviation: 'WI', label: 'Wisconsin' },
    { abbreviation: 'WY', label: 'Wyoming' }
  ];

  public static US_STATES_PRISM: Array<PrismDropDown> = [
    { value: 'AL', viewValue: 'Alabama' },
    { value: 'AK', viewValue: 'Alaska' },
    { value: 'AS', viewValue: 'American Samoa' },
    { value: 'AZ', viewValue: 'Arizona' },
    { value: 'AR', viewValue: 'Arkansas' },
    //{ value: 'AA', viewValue: 'Armed Forces Americas (excluding Canada)' },
    //{ value: 'AE', viewValue: 'Armed Forces Europe,Middle East,Africa,Canada' },
    //{ value: 'AP', viewValue: 'Armed Forces Pacific' },
    { value: 'CA', viewValue: 'California' },
    //{ value: 'CN', viewValue: 'Central' },
    { value: 'CO', viewValue: 'Colorado' },
    { value: 'CT', viewValue: 'Connecticut' },
    { value: 'DE', viewValue: 'Delaware' },
    { value: 'DC', viewValue: 'District of Columbia' },
    //{ value: 'FM', viewValue: 'Federated States of Micronesia' },
    { value: 'FL', viewValue: 'Florida' },
    { value: 'GA', viewValue: 'Georgia' },
    { value: 'GU', viewValue: 'Guam' },
    { value: 'HI', viewValue: 'Hawaii' },
    { value: 'ID', viewValue: 'Idaho' },
    { value: 'IL', viewValue: 'Illinois' },
    { value: 'IN', viewValue: 'Indiana' },
    { value: 'IA', viewValue: 'Iowa' },
    { value: 'KS', viewValue: 'Kansas' },
    { value: 'KY', viewValue: 'Kentucky' },
    { value: 'LA', viewValue: 'Louisiana' },
    { value: 'ME', viewValue: 'Maine' },
    //{ value: 'MH', viewValue: 'Marshall Islands' },
    { value: 'MD', viewValue: 'Maryland' },
    { value: 'MA', viewValue: 'Massachusetts' },
    { value: 'MI', viewValue: 'Michigan' },
    { value: 'MN', viewValue: 'Minnesota' },
    { value: 'MS', viewValue: 'Mississippi' },
    { value: 'MO', viewValue: 'Missouri' },
    { value: 'MT', viewValue: 'Montana' },
    { value: 'NE', viewValue: 'Nebraska' },
    { value: 'NV', viewValue: 'Nevada' },
    { value: 'NH', viewValue: 'New Hampshire' },
    { value: 'NJ', viewValue: 'New Jersey' },
    { value: 'NM', viewValue: 'New Mexico' },
    { value: 'NY', viewValue: 'New York' },
    { value: 'NC', viewValue: 'North Carolina' },
    { value: 'ND', viewValue: 'North Dakota' },
    //{ value: 'EN', viewValue: 'Northeastern' },
    { value: 'MP', viewValue: 'Northern Mariana Islands' },
    { value: 'OH', viewValue: 'Ohio' },
    { value: 'OK', viewValue: 'Oklahoma' },
    { value: 'OR', viewValue: 'Oregon' },
    //{ value: 'PW', viewValue: 'Palau' },
    { value: 'PA', viewValue: 'Pennsylvania' },
    { value: 'PR', viewValue: 'Puerto Rico' },
    { value: 'RI', viewValue: 'Rhode Island' },
    { value: 'SC', viewValue: 'South Carolina' },
    { value: 'SD', viewValue: 'South Dakota' },
    //{ value: 'SE', viewValue: 'Southeastern' },
    { value: 'TN', viewValue: 'Tennessee' },
    { value: 'TX', viewValue: 'Texas' },
    { value: 'UT', viewValue: 'Utah' },
    { value: 'VT', viewValue: 'Vermont' },
    { value: 'VI', viewValue: 'Virgin Islands, U.S.' },
    { value: 'VA', viewValue: 'Virginia' },
    { value: 'WA', viewValue: 'Washington' },
    { value: 'WV', viewValue: 'West Virginia' },
    //{ value: 'WS', viewValue: 'Western' },
    { value: 'WI', viewValue: 'Wisconsin' },
    { value: 'WY', viewValue: 'Wyoming' }
  ];

  public static US_STATES_NM_PRISM: Array<PrismDropDown> = [
    { value: 'AL', viewValue: 'Alabama' },
    { value: 'AK', viewValue: 'Alaska' },
    { value: 'AZ', viewValue: 'Arizona' },
    { value: 'AR', viewValue: 'Arkansas' },
    { value: 'CA', viewValue: 'California' },
    { value: 'CO', viewValue: 'Colorado' },
    { value: 'CT', viewValue: 'Connecticut' },
    { value: 'DC', viewValue: 'District of Columbia' },
    { value: 'DE', viewValue: 'Delaware' },
    { value: 'FL', viewValue: 'Florida' },
    { value: 'GA', viewValue: 'Georgia' },
    { value: 'HI', viewValue: 'Hawaii' },
    { value: 'ID', viewValue: 'Idaho' },
    { value: 'IL', viewValue: 'Illinois' },
    { value: 'IN', viewValue: 'Indiana' },
    { value: 'IA', viewValue: 'Iowa' },
    { value: 'KS', viewValue: 'Kansas' },
    { value: 'KY', viewValue: 'Kentucky' },
    { value: 'LA', viewValue: 'Louisiana' },
    { value: 'ME', viewValue: 'Maine' },
    { value: 'MD', viewValue: 'Maryland' },
    { value: 'MI', viewValue: 'Michigan' },
    { value: 'MN', viewValue: 'Minnesota' },
    { value: 'MS', viewValue: 'Mississippi' },
    { value: 'MO', viewValue: 'Missouri' },
    { value: 'MT', viewValue: 'Montana' },
    { value: 'NE', viewValue: 'Nebraska' },
    { value: 'NV', viewValue: 'Nevada' },
    { value: 'NH', viewValue: 'New Hampshire' },
    { value: 'NJ', viewValue: 'New Jersey' },
    { value: 'NM', viewValue: 'New Mexico' },
    { value: 'NC', viewValue: 'North Carolina' },
    { value: 'ND', viewValue: 'North Dakota' },
    { value: 'OH', viewValue: 'Ohio' },
    { value: 'OK', viewValue: 'Oklahoma' },
    { value: 'OR', viewValue: 'Oregon' },
    { value: 'PA', viewValue: 'Pennsylvania' },
    { value: 'RI', viewValue: 'Rhode Island' },
    { value: 'SC', viewValue: 'South Carolina' },
    { value: 'SD', viewValue: 'South Dakota' },
    { value: 'TN', viewValue: 'Tennessee' },
    { value: 'TX', viewValue: 'Texas' },
    { value: 'UT', viewValue: 'Utah' },
    { value: 'VT', viewValue: 'Vermont' },
    { value: 'VA', viewValue: 'Virginia' },
    { value: 'WA', viewValue: 'Washington' },
    { value: 'WV', viewValue: 'West Virginia' },
    { value: 'WI', viewValue: 'Wisconsin' },
    { value: 'WY', viewValue: 'Wyoming' }
  ];

  public static US_BIRTH_STATES: Array<StateRegion> = [
    { abbreviation: 'AL', label: 'Alabama' },
    { abbreviation: 'AK', label: 'Alaska' },
    { abbreviation: 'AS', label: 'American Samoa' },
    { abbreviation: 'AZ', label: 'Arizona' },
    { abbreviation: 'AR', label: 'Arkansas' },
    { abbreviation: 'CA', label: 'California' },
    { abbreviation: 'CO', label: 'Colorado' },
    { abbreviation: 'CT', label: 'Connecticut' },
    { abbreviation: 'DE', label: 'Delaware' },
    { abbreviation: 'DC', label: 'District of Columbia' },
    { abbreviation: 'FL', label: 'Florida' },
    { abbreviation: 'GA', label: 'Georgia' },
    { abbreviation: 'GU', label: 'Guam' },
    { abbreviation: 'HI', label: 'Hawaii' },
    { abbreviation: 'ID', label: 'Idaho' },
    { abbreviation: 'IL', label: 'Illinois' },
    { abbreviation: 'IN', label: 'Indiana' },
    { abbreviation: 'IA', label: 'Iowa' },
    { abbreviation: 'KS', label: 'Kansas' },
    { abbreviation: 'KY', label: 'Kentucky' },
    { abbreviation: 'LA', label: 'Louisiana' },
    { abbreviation: 'ME', label: 'Maine' },
    { abbreviation: 'MD', label: 'Maryland' },
    { abbreviation: 'MA', label: 'Massachusetts' },
    { abbreviation: 'MI', label: 'Michigan' },
    { abbreviation: 'MN', label: 'Minnesota' },
    { abbreviation: 'MS', label: 'Mississippi' },
    { abbreviation: 'MO', label: 'Missouri' },
    { abbreviation: 'MT', label: 'Montana' },
    { abbreviation: 'NE', label: 'Nebraska' },
    { abbreviation: 'NV', label: 'Nevada' },
    { abbreviation: 'NH', label: 'New Hampshire' },
    { abbreviation: 'NJ', label: 'New Jersey' },
    { abbreviation: 'NM', label: 'New Mexico' },
    { abbreviation: 'NY', label: 'New York' },
    { abbreviation: 'NC', label: 'North Carolina' },
    { abbreviation: 'ND', label: 'North Dakota' },
    { abbreviation: 'MP', label: 'Northern Mariana Islands' },
    { abbreviation: 'OH', label: 'Ohio' },
    { abbreviation: 'OK', label: 'Oklahoma' },
    { abbreviation: 'OR', label: 'Oregon' },
    { abbreviation: 'PA', label: 'Pennsylvania' },
    { abbreviation: 'PR', label: 'Puerto Rico' },
    { abbreviation: 'RI', label: 'Rhode Island' },
    { abbreviation: 'SC', label: 'South Carolina' },
    { abbreviation: 'SD', label: 'South Dakota' },
    { abbreviation: 'TN', label: 'Tennessee' },
    { abbreviation: 'TX', label: 'Texas' },
    { abbreviation: 'UT', label: 'Utah' },
    { abbreviation: 'VT', label: 'Vermont' },
    { abbreviation: 'VI', label: 'Virgin Islands U.S.' },
    { abbreviation: 'VA', label: 'Virginia' },
    { abbreviation: 'WA', label: 'Washington' },
    { abbreviation: 'WV', label: 'West Virginia' },
    { abbreviation: 'WI', label: 'Wisconsin' },
    { abbreviation: 'WY', label: 'Wyoming' }
  ];

  public static US_BIRTH_STATES_PRISM: Array<PrismDropDown> = [
    { value: 'AL', viewValue: 'Alabama' },
    { value: 'AK', viewValue: 'Alaska' },
    { value: 'AS', viewValue: 'American Samoa' },
    { value: 'AZ', viewValue: 'Arizona' },
    { value: 'AR', viewValue: 'Arkansas' },
    { value: 'CA', viewValue: 'California' },
    { value: 'CO', viewValue: 'Colorado' },
    { value: 'CT', viewValue: 'Connecticut' },
    { value: 'DE', viewValue: 'Delaware' },
    { value: 'DC', viewValue: 'District of Columbia' },
    { value: 'FL', viewValue: 'Florida' },
    { value: 'GA', viewValue: 'Georgia' },
    { value: 'GU', viewValue: 'Guam' },
    { value: 'HI', viewValue: 'Hawaii' },
    { value: 'ID', viewValue: 'Idaho' },
    { value: 'IL', viewValue: 'Illinois' },
    { value: 'IN', viewValue: 'Indiana' },
    { value: 'IA', viewValue: 'Iowa' },
    { value: 'KS', viewValue: 'Kansas' },
    { value: 'KY', viewValue: 'Kentucky' },
    { value: 'LA', viewValue: 'Louisiana' },
    { value: 'ME', viewValue: 'Maine' },
    { value: 'MD', viewValue: 'Maryland' },
    { value: 'MA', viewValue: 'Massachusetts' },
    { value: 'MI', viewValue: 'Michigan' },
    { value: 'MN', viewValue: 'Minnesota' },
    { value: 'MS', viewValue: 'Mississippi' },
    { value: 'MO', viewValue: 'Missouri' },
    { value: 'MT', viewValue: 'Montana' },
    { value: 'NE', viewValue: 'Nebraska' },
    { value: 'NV', viewValue: 'Nevada' },
    { value: 'NH', viewValue: 'New Hampshire' },
    { value: 'NJ', viewValue: 'New Jersey' },
    { value: 'NM', viewValue: 'New Mexico' },
    { value: 'NY', viewValue: 'New York' },
    { value: 'NC', viewValue: 'North Carolina' },
    { value: 'ND', viewValue: 'North Dakota' },
    { value: 'MP', viewValue: 'Northern Mariana Islands' },
    { value: 'OH', viewValue: 'Ohio' },
    { value: 'OK', viewValue: 'Oklahoma' },
    { value: 'OR', viewValue: 'Oregon' },
    { value: 'PA', viewValue: 'Pennsylvania' },
    { value: 'PR', viewValue: 'Puerto Rico' },
    { value: 'RI', viewValue: 'Rhode Island' },
    { value: 'SC', viewValue: 'South Carolina' },
    { value: 'SD', viewValue: 'South Dakota' },
    { value: 'TN', viewValue: 'Tennessee' },
    { value: 'TX', viewValue: 'Texas' },
    { value: 'UT', viewValue: 'Utah' },
    { value: 'VT', viewValue: 'Vermont' },
    { value: 'VI', viewValue: 'Virgin Islands U.S.' },
    { value: 'VA', viewValue: 'Virginia' },
    { value: 'WA', viewValue: 'Washington' },
    { value: 'WV', viewValue: 'West Virginia' },
    { value: 'WI', viewValue: 'Wisconsin' },
    { value: 'WY', viewValue: 'Wyoming' }
  ];

  public static readonly RESIDENCE_COUNTRIES: Array<StateRegion> = [
    { abbreviation: 'US', label: 'United States' },
    { abbreviation: 'OT', label: 'Outside the U.S.' }
  ];
  public static readonly RESIDENCE_COUNTRIES_PRISM: Array<PrismDropDown> = [
    { value: 'US', viewValue: 'United States' },
    { value: 'OT', viewValue: 'Outside the U.S.' }
  ];
  public static readonly COUNTRIES: Array<StateRegion> = [
    { abbreviation: "AF", label: "Afghanistan"},
    { abbreviation: "AX", label: "Aland Islands"},
    { abbreviation: "AL", label: "Albania"},
    { abbreviation: "DZ", label: "Algeria"},
    { abbreviation: "AS", label: "American Samoa"},
    { abbreviation: "AD", label: "Andorra"},
    { abbreviation: "AO", label: "Angola"},
    { abbreviation: "AI", label: "Anguilla"},
    { abbreviation: "AQ", label: "Antarctica"},
    { abbreviation: "AG", label: "Antigua and Barbuda"},
    { abbreviation: "AR", label: "Argentina"},
    { abbreviation: "AM", label: "Armenia"},
    { abbreviation: "AW", label: "Aruba"},
    { abbreviation: "AU", label: "Australia"},
    { abbreviation: "AT", label: "Austria"},
    { abbreviation: "AZ", label: "Azerbaijan"},
    { abbreviation: "BS", label: "Bahamas"},
    { abbreviation: "BH", label: "Bahrain"},
    { abbreviation: "BD", label: "Bangladesh"},
    { abbreviation: "BB", label: "Barbados"},
    { abbreviation: "BY", label: "Belarus"},
    { abbreviation: "BE", label: "Belgium"},
    { abbreviation: "BZ", label: "Belize"},
    { abbreviation: "BJ", label: "Benin"},
    { abbreviation: "BM", label: "Bermuda"},
    { abbreviation: "BT", label: "Bhutan"},
    { abbreviation: "BO", label: "Bolivia"},
    { abbreviation: "BQ", label: "Bonaire, Sint Eustatius and Saba"},
    { abbreviation: "BA", label: "Bosnia and Herzegovina"},
    { abbreviation: "BW", label: "Botswana"},
    { abbreviation: "BV", label: "Bouvet Island"},
    { abbreviation: "BR", label: "Brazil"},
    { abbreviation: "IO", label: "British Indian Ocean Territory"},
    { abbreviation: "BN", label: "Brunei Darussalam"},
    { abbreviation: "BG", label: "Bulgaria"},
    { abbreviation: "BF", label: "Burkina Faso"},
    { abbreviation: "BI", label: "Burundi"},
    { abbreviation: "CV", label: "Cabo Verde"},
    { abbreviation: "KH", label: "Cambodia"},
    { abbreviation: "CM", label: "Cameroon"},
    { abbreviation: "CA", label: "Canada"},
    { abbreviation: "KY", label: "Cayman Islands"},
    { abbreviation: "CF", label: "Central African Republic"},
    { abbreviation: "TD", label: "Chad"},
    { abbreviation: "CL", label: "Chile"},
    { abbreviation: "CN", label: "China"},
    { abbreviation: "CX", label: "Christmas Island"},
    { abbreviation: "CO", label: "Colombia"},
    { abbreviation: "KM", label: "Comoros"},
    { abbreviation: "CD", label: "Congo"},
    { abbreviation: "CK", label: "Cook Islands"},
    { abbreviation: "CR", label: "Costa Rica"},
    { abbreviation: "HR", label: "Croatia"},
    { abbreviation: "CU", label: "Cuba"},
    { abbreviation: "CW", label: "Curaçao"},
    { abbreviation: "CY", label: "Cyprus"},
    { abbreviation: "CZ", label: "Czechia"},
    { abbreviation: "DK", label: "Denmark"},
    { abbreviation: "DJ", label: "Djibouti"},
    { abbreviation: "DM", label: "Dominica"},
    { abbreviation: "DO", label: "Dominican Republic"},
    { abbreviation: "EC", label: "Ecuador"},
    { abbreviation: "EG", label: "Egypt"},
    { abbreviation: "SV", label: "El Salvador"},
    { abbreviation: "GQ", label: "Equatorial Guinea"},
    { abbreviation: "ER", label: "Eritrea"},
    { abbreviation: "EE", label: "Estonia"},
    { abbreviation: "SZ", label: "Eswatini"},
    { abbreviation: "ET", label: "Ethiopia"},
    { abbreviation: "FK", label: "Falkland Islands"},
    { abbreviation: "FO", label: "Faroe Islands"},
    { abbreviation: "FJ", label: "Fiji"},
    { abbreviation: "FI", label: "Finland"},
    { abbreviation: "FR", label: "France"},
    { abbreviation: "GF", label: "French Guiana"},
    { abbreviation: "PF", label: "French Polynesia"},
    { abbreviation: "TF", label: "French Southern Territories"},
    { abbreviation: "GA", label: "Gabon"},
    { abbreviation: "GM", label: "Gambia"},
    { abbreviation: "GE", label: "Georgia"},
    { abbreviation: "DE", label: "Germany"},
    { abbreviation: "GH", label: "Ghana"},
    { abbreviation: "GI", label: "Gibraltar"},
    { abbreviation: "GR", label: "Greece"},
    { abbreviation: "GL", label: "Greenland"},
    { abbreviation: "GD", label: "Grenada"},
    { abbreviation: "GP", label: "Guadeloupe"},
    { abbreviation: "GU", label: "Guam"},
    { abbreviation: "GT", label: "Guatemala"},
    { abbreviation: "GG", label: "Guernsey"},
    { abbreviation: "GN", label: "Guinea"},
    { abbreviation: "GW", label: "Guinea-Bissau"},
    { abbreviation: "GY", label: "Guyana"},
    { abbreviation: "HT", label: "Haiti"},
    { abbreviation: "HM", label: "Heard Island and McDonald Islands"},
    { abbreviation: "VA", label: "Holy See"},
    { abbreviation: "HN", label: "Honduras"},
    { abbreviation: "HK", label: "Hong Kong"},
    { abbreviation: "HU", label: "Hungary"},
    { abbreviation: "IS", label: "Iceland"},
    { abbreviation: "IN", label: "India"},
    { abbreviation: "ID", label: "Indonesia"},
    { abbreviation: "IR", label: "Iran"},
    { abbreviation: "IQ", label: "Iraq"},
    { abbreviation: "IE", label: "Ireland"},
    { abbreviation: "IM", label: "Isle of Man"},
    { abbreviation: "IL", label: "Israel"},
    { abbreviation: "IT", label: "Italy"},
    { abbreviation: "CI", label: "Ivory Coast Côte d'Ivoire"},
    { abbreviation: "JM", label: "Jamaica"},
    { abbreviation: "JP", label: "Japan"},
    { abbreviation: "JE", label: "Jersey"},
    { abbreviation: "JO", label: "Jordan"},
    { abbreviation: "KZ", label: "Kazakhstan"},
    { abbreviation: "KE", label: "Kenya"},
    { abbreviation: "KI", label: "Kiribati"},
    { abbreviation: "KP", label: "Korea (the Democratic People's Republic of)"},
    { abbreviation: "KR", label: "Korea (the Republic of)"},
    { abbreviation: "KW", label: "Kuwait"},
    { abbreviation: "KG", label: "Kyrgyzstan"},
    { abbreviation: "LA", label: "Laos"},
    { abbreviation: "LV", label: "Latvia"},
    { abbreviation: "LB", label: "Lebanon"},
    { abbreviation: "LS", label: "Lesotho"},
    { abbreviation: "LR", label: "Liberia"},
    { abbreviation: "LY", label: "Libya"},
    { abbreviation: "LI", label: "Liechtenstein"},
    { abbreviation: "LT", label: "Lithuania"},
    { abbreviation: "LU", label: "Luxembourg"},
    { abbreviation: "MO", label: "Macao"},
    { abbreviation: "MG", label: "Madagascar"},
    { abbreviation: "MW", label: "Malawi"},
    { abbreviation: "MY", label: "Malaysia"},
    { abbreviation: "MV", label: "Maldives"},
    { abbreviation: "ML", label: "Mali"},
    { abbreviation: "MT", label: "Malta"},
    { abbreviation: "MH", label: "Marshall Islands"},
    { abbreviation: "MQ", label: "Martinique"},
    { abbreviation: "MR", label: "Mauritania"},
    { abbreviation: "MU", label: "Mauritius"},
    { abbreviation: "YT", label: "Mayotte"},
    { abbreviation: "MX", label: "Mexico"},
    { abbreviation: "FM", label: "Micronesia"},
    { abbreviation: "MD", label: "Moldova"},
    { abbreviation: "MC", label: "Monaco"},
    { abbreviation: "MN", label: "Mongolia"},
    { abbreviation: "ME", label: "Montenegro"},
    { abbreviation: "MS", label: "Montserrat"},
    { abbreviation: "MA", label: "Morocco"},
    { abbreviation: "MZ", label: "Mozambique"},
    { abbreviation: "MM", label: "Myanmar"},
    { abbreviation: "NA", label: "Namibia"},
    { abbreviation: "NR", label: "Nauru"},
    { abbreviation: "NP", label: "Nepal"},
    { abbreviation: "NL", label: "Netherlands"},
    { abbreviation: "NC", label: "New Caledonia"},
    { abbreviation: "NZ", label: "New Zealand"},
    { abbreviation: "NI", label: "Nicaragua"},
    { abbreviation: "NE", label: "Niger"},
    { abbreviation: "NG", label: "Nigeria"},
    { abbreviation: "NU", label: "Niue"},
    { abbreviation: "NF", label: "Norfolk Island"},
    { abbreviation: "MK", label: "North Macedonia"},
    { abbreviation: "MP", label: "Northern Mariana Islands"},
    { abbreviation: "NO", label: "Norway"},
    { abbreviation: "OM", label: "Oman"},
    { abbreviation: "PK", label: "Pakistan"},
    { abbreviation: "PW", label: "Palau"},
    { abbreviation: "PS", label: "Palestine"},
    { abbreviation: "PA", label: "Panama"},
    { abbreviation: "PG", label: "Papua New Guinea"},
    { abbreviation: "PY", label: "Paraguay"},
    { abbreviation: "PE", label: "Peru"},
    { abbreviation: "PH", label: "Philippines"},
    { abbreviation: "PN", label: "Pitcairn"},
    { abbreviation: "PL", label: "Poland"},
    { abbreviation: "PT", label: "Portugal"},
    { abbreviation: "PR", label: "Puerto Rico"},
    { abbreviation: "QA", label: "Qatar"},
    { abbreviation: "CG", label: "Republic of the Congo"},
    { abbreviation: "RE", label: "Réunion"},
    { abbreviation: "RO", label: "Romania"},
    { abbreviation: "RU", label: "Russia"},
    { abbreviation: "RW", label: "Rwanda"},
    { abbreviation: "BL", label: "Saint Barthélemy"},
    { abbreviation: "SH", label: "Saint Helena, Ascension and Tristan da Cunha"},
    { abbreviation: "KN", label: "Saint Kitts and Nevis"},
    { abbreviation: "LC", label: "Saint Lucia"},
    { abbreviation: "MF", label: "Saint Martin (French part)"},
    { abbreviation: "PM", label: "Saint Pierre and Miquelon"},
    { abbreviation: "VC", label: "Saint Vincent and the Grenadines"},
    { abbreviation: "WS", label: "Samoa"},
    { abbreviation: "SM", label: "San Marino"},
    { abbreviation: "ST", label: "Sao Tome and Principe"},
    { abbreviation: "SA", label: "Saudi Arabia"},
    { abbreviation: "SN", label: "Senegal"},
    { abbreviation: "RS", label: "Serbia"},
    { abbreviation: "SC", label: "Seychelles"},
    { abbreviation: "SL", label: "Sierra Leone"},
    { abbreviation: "SG", label: "Singapore"},
    { abbreviation: "SX", label: "Sint Maarten (Dutch part)"},
    { abbreviation: "SK", label: "Slovakia"},
    { abbreviation: "SI", label: "Slovenia"},
    { abbreviation: "SB", label: "Solomon Islands"},
    { abbreviation: "SO", label: "Somalia"},
    { abbreviation: "ZA", label: "South Africa"},
    { abbreviation: "GS", label: "South Georgia and the South Sandwich Islands"},
    { abbreviation: "SS", label: "South Sudan"},
    { abbreviation: "ES", label: "Spain"},
    { abbreviation: "LK", label: "Sri Lanka"},
    { abbreviation: "SD", label: "Sudan"},
    { abbreviation: "SR", label: "Suriname"},
    { abbreviation: "SJ", label: "Svalbard Jan Mayen"},
    { abbreviation: "SE", label: "Sweden"},
    { abbreviation: "CH", label: "Switzerland"},
    { abbreviation: "SY", label: "Syria"},
    { abbreviation: "TW", label: "Taiwan"},
    { abbreviation: "TJ", label: "Tajikistan"},
    { abbreviation: "TZ", label: "Tanzania"},
    { abbreviation: "CC", label: "Territory of Cocos (Keeling) Islands"},
    { abbreviation: "TH", label: "Thailand"},
    { abbreviation: "TL", label: "Timor-Leste"},
    { abbreviation: "TG", label: "Togo"},
    { abbreviation: "TK", label: "Tokelau"},
    { abbreviation: "TO", label: "Tonga"},
    { abbreviation: "TT", label: "Trinidad and Tobago"},
    { abbreviation: "TN", label: "Tunisia"},
    { abbreviation: "TR", label: "Türkiye"},
    { abbreviation: "TM", label: "Turkmenistan"},
    { abbreviation: "TC", label: "Turks and Caicos Islands"},
    { abbreviation: "TV", label: "Tuvalu"},
    { abbreviation: "UG", label: "Uganda"},
    { abbreviation: "UA", label: "Ukraine"},
    { abbreviation: "AE", label: "United Arab Emirates"},
    { abbreviation: "GB", label: "United Kingdom"},
    { abbreviation: "UM", label: "United States Minor Outlying Islands"},
    { abbreviation: "US", label: "United States of America"},
    { abbreviation: "UY", label: "Uruguay"},
    { abbreviation: "UZ", label: "Uzbekistan"},
    { abbreviation: "VU", label: "Vanuatu"},
    { abbreviation: "VE", label: "Venezuela"},
    { abbreviation: "VN", label: "Viet Nam"},
    { abbreviation: "VG", label: "Virgin Islands (British)"},
    { abbreviation: "VI", label: "Virgin Islands (US)"},
    { abbreviation: "WF", label: "Wallis and Futuna"},
    { abbreviation: "EH", label: "Western Sahara"},
    { abbreviation: "YE", label: "Yemen"},
    { abbreviation: "YU", label: "Yugoslavia"},
    { abbreviation: "ZM", label: "Zambia"},
    { abbreviation: "ZW", label: "Zimbabwe"}
  ];

  public static readonly COUNTRIES_PRISM: Array<PrismDropDown> = [
    { value: "AF", viewValue: "Afghanistan"},
    { value: "AX", viewValue: "Aland Islands"},
    { value: "AL", viewValue: "Albania"},
    { value: "DZ", viewValue: "Algeria"},
    { value: "AS", viewValue: "American Samoa"},
    { value: "AD", viewValue: "Andorra"},
    { value: "AO", viewValue: "Angola"},
    { value: "AI", viewValue: "Anguilla"},
    { value: "AQ", viewValue: "Antarctica"},
    { value: "AG", viewValue: "Antigua and Barbuda"},
    { value: "AR", viewValue: "Argentina"},
    { value: "AM", viewValue: "Armenia"},
    { value: "AW", viewValue: "Aruba"},
    { value: "AU", viewValue: "Australia"},
    { value: "AT", viewValue: "Austria"},
    { value: "AZ", viewValue: "Azerbaijan"},
    { value: "BS", viewValue: "Bahamas"},
    { value: "BH", viewValue: "Bahrain"},
    { value: "BD", viewValue: "Bangladesh"},
    { value: "BB", viewValue: "Barbados"},
    { value: "BY", viewValue: "Belarus"},
    { value: "BE", viewValue: "Belgium"},
    { value: "BZ", viewValue: "Belize"},
    { value: "BJ", viewValue: "Benin"},
    { value: "BM", viewValue: "Bermuda"},
    { value: "BT", viewValue: "Bhutan"},
    { value: "BO", viewValue: "Bolivia"},
    { value: "BQ", viewValue: "Bonaire, Sint Eustatius and Saba"},
    { value: "BA", viewValue: "Bosnia and Herzegovina"},
    { value: "BW", viewValue: "Botswana"},
    { value: "BV", viewValue: "Bouvet Island"},
    { value: "BR", viewValue: "Brazil"},
    { value: "IO", viewValue: "British Indian Ocean Territory"},
    { value: "BN", viewValue: "Brunei Darussalam"},
    { value: "BG", viewValue: "Bulgaria"},
    { value: "BF", viewValue: "Burkina Faso"},
    { value: "BI", viewValue: "Burundi"},
    { value: "CV", viewValue: "Cabo Verde"},
    { value: "KH", viewValue: "Cambodia"},
    { value: "CM", viewValue: "Cameroon"},
    { value: "CA", viewValue: "Canada"},
    { value: "KY", viewValue: "Cayman Islands"},
    { value: "CF", viewValue: "Central African Republic"},
    { value: "TD", viewValue: "Chad"},
    { value: "CL", viewValue: "Chile"},
    { value: "CN", viewValue: "China"},
    { value: "CX", viewValue: "Christmas Island"},
    { value: "CO", viewValue: "Colombia"},
    { value: "KM", viewValue: "Comoros"},
    { value: "CD", viewValue: "Congo"},
    { value: "CK", viewValue: "Cook Islands"},
    { value: "CR", viewValue: "Costa Rica"},
    { value: "HR", viewValue: "Croatia"},
    { value: "CU", viewValue: "Cuba"},
    { value: "CW", viewValue: "Curaçao"},
    { value: "CY", viewValue: "Cyprus"},
    { value: "CZ", viewValue: "Czechia"},
    { value: "DK", viewValue: "Denmark"},
    { value: "DJ", viewValue: "Djibouti"},
    { value: "DM", viewValue: "Dominica"},
    { value: "DO", viewValue: "Dominican Republic"},
    { value: "EC", viewValue: "Ecuador"},
    { value: "EG", viewValue: "Egypt"},
    { value: "SV", viewValue: "El Salvador"},
    { value: "GQ", viewValue: "Equatorial Guinea"},
    { value: "ER", viewValue: "Eritrea"},
    { value: "EE", viewValue: "Estonia"},
    { value: "SZ", viewValue: "Eswatini"},
    { value: "ET", viewValue: "Ethiopia"},
    { value: "FK", viewValue: "Falkland Islands"},
    { value: "FO", viewValue: "Faroe Islands"},
    { value: "FJ", viewValue: "Fiji"},
    { value: "FI", viewValue: "Finland"},
    { value: "FR", viewValue: "France"},
    { value: "GF", viewValue: "French Guiana"},
    { value: "PF", viewValue: "French Polynesia"},
    { value: "TF", viewValue: "French Southern Territories"},
    { value: "GA", viewValue: "Gabon"},
    { value: "GM", viewValue: "Gambia"},
    { value: "GE", viewValue: "Georgia"},
    { value: "DE", viewValue: "Germany"},
    { value: "GH", viewValue: "Ghana"},
    { value: "GI", viewValue: "Gibraltar"},
    { value: "GR", viewValue: "Greece"},
    { value: "GL", viewValue: "Greenland"},
    { value: "GD", viewValue: "Grenada"},
    { value: "GP", viewValue: "Guadeloupe"},
    { value: "GU", viewValue: "Guam"},
    { value: "GT", viewValue: "Guatemala"},
    { value: "GG", viewValue: "Guernsey"},
    { value: "GN", viewValue: "Guinea"},
    { value: "GW", viewValue: "Guinea-Bissau"},
    { value: "GY", viewValue: "Guyana"},
    { value: "HT", viewValue: "Haiti"},
    { value: "HM", viewValue: "Heard Island and McDonald Islands"},
    { value: "VA", viewValue: "Holy See"},
    { value: "HN", viewValue: "Honduras"},
    { value: "HK", viewValue: "Hong Kong"},
    { value: "HU", viewValue: "Hungary"},
    { value: "IS", viewValue: "Iceland"},
    { value: "IN", viewValue: "India"},
    { value: "ID", viewValue: "Indonesia"},
    { value: "IR", viewValue: "Iran"},
    { value: "IQ", viewValue: "Iraq"},
    { value: "IE", viewValue: "Ireland"},
    { value: "IM", viewValue: "Isle of Man"},
    { value: "IL", viewValue: "Israel"},
    { value: "IT", viewValue: "Italy"},
    { value: "CI", viewValue: "Ivory Coast Côte d'Ivoire"},
    { value: "JM", viewValue: "Jamaica"},
    { value: "JP", viewValue: "Japan"},
    { value: "JE", viewValue: "Jersey"},
    { value: "JO", viewValue: "Jordan"},
    { value: "KZ", viewValue: "Kazakhstan"},
    { value: "KE", viewValue: "Kenya"},
    { value: "KI", viewValue: "Kiribati"},
    { value: "KP", viewValue: "Korea (the Democratic People's Republic of)"},
    { value: "KR", viewValue: "Korea (the Republic of)"},
    { value: "KW", viewValue: "Kuwait"},
    { value: "KG", viewValue: "Kyrgyzstan"},
    { value: "LA", viewValue: "Laos"},
    { value: "LV", viewValue: "Latvia"},
    { value: "LB", viewValue: "Lebanon"},
    { value: "LS", viewValue: "Lesotho"},
    { value: "LR", viewValue: "Liberia"},
    { value: "LY", viewValue: "Libya"},
    { value: "LI", viewValue: "Liechtenstein"},
    { value: "LT", viewValue: "Lithuania"},
    { value: "LU", viewValue: "Luxembourg"},
    { value: "MO", viewValue: "Macao"},
    { value: "MG", viewValue: "Madagascar"},
    { value: "MW", viewValue: "Malawi"},
    { value: "MY", viewValue: "Malaysia"},
    { value: "MV", viewValue: "Maldives"},
    { value: "ML", viewValue: "Mali"},
    { value: "MT", viewValue: "Malta"},
    { value: "MH", viewValue: "Marshall Islands"},
    { value: "MQ", viewValue: "Martinique"},
    { value: "MR", viewValue: "Mauritania"},
    { value: "MU", viewValue: "Mauritius"},
    { value: "YT", viewValue: "Mayotte"},
    { value: "MX", viewValue: "Mexico"},
    { value: "FM", viewValue: "Micronesia"},
    { value: "MD", viewValue: "Moldova"},
    { value: "MC", viewValue: "Monaco"},
    { value: "MN", viewValue: "Mongolia"},
    { value: "ME", viewValue: "Montenegro"},
    { value: "MS", viewValue: "Montserrat"},
    { value: "MA", viewValue: "Morocco"},
    { value: "MZ", viewValue: "Mozambique"},
    { value: "MM", viewValue: "Myanmar"},
    { value: "NA", viewValue: "Namibia"},
    { value: "NR", viewValue: "Nauru"},
    { value: "NP", viewValue: "Nepal"},
    { value: "NL", viewValue: "Netherlands"},
    { value: "NC", viewValue: "New Caledonia"},
    { value: "NZ", viewValue: "New Zealand"},
    { value: "NI", viewValue: "Nicaragua"},
    { value: "NE", viewValue: "Niger"},
    { value: "NG", viewValue: "Nigeria"},
    { value: "NU", viewValue: "Niue"},
    { value: "NF", viewValue: "Norfolk Island"},
    { value: "MK", viewValue: "North Macedonia"},
    { value: "MP", viewValue: "Northern Mariana Islands"},
    { value: "NO", viewValue: "Norway"},
    { value: "OM", viewValue: "Oman"},
    { value: "PK", viewValue: "Pakistan"},
    { value: "PW", viewValue: "Palau"},
    { value: "PS", viewValue: "Palestine"},
    { value: "PA", viewValue: "Panama"},
    { value: "PG", viewValue: "Papua New Guinea"},
    { value: "PY", viewValue: "Paraguay"},
    { value: "PE", viewValue: "Peru"},
    { value: "PH", viewValue: "Philippines"},
    { value: "PN", viewValue: "Pitcairn"},
    { value: "PL", viewValue: "Poland"},
    { value: "PT", viewValue: "Portugal"},
    { value: "PR", viewValue: "Puerto Rico"},
    { value: "QA", viewValue: "Qatar"},
    { value: "CG", viewValue: "Republic of the Congo"},
    { value: "RE", viewValue: "Réunion"},
    { value: "RO", viewValue: "Romania"},
    { value: "RU", viewValue: "Russia"},
    { value: "RW", viewValue: "Rwanda"},
    { value: "BL", viewValue: "Saint Barthélemy"},
    { value: "SH", viewValue: "Saint Helena, Ascension and Tristan da Cunha"},
    { value: "KN", viewValue: "Saint Kitts and Nevis"},
    { value: "LC", viewValue: "Saint Lucia"},
    { value: "MF", viewValue: "Saint Martin (French part)"},
    { value: "PM", viewValue: "Saint Pierre and Miquelon"},
    { value: "VC", viewValue: "Saint Vincent and the Grenadines"},
    { value: "WS", viewValue: "Samoa"},
    { value: "SM", viewValue: "San Marino"},
    { value: "ST", viewValue: "Sao Tome and Principe"},
    { value: "SA", viewValue: "Saudi Arabia"},
    { value: "SN", viewValue: "Senegal"},
    { value: "RS", viewValue: "Serbia"},
    { value: "SC", viewValue: "Seychelles"},
    { value: "SL", viewValue: "Sierra Leone"},
    { value: "SG", viewValue: "Singapore"},
    { value: "SX", viewValue: "Sint Maarten (Dutch part)"},
    { value: "SK", viewValue: "Slovakia"},
    { value: "SI", viewValue: "Slovenia"},
    { value: "SB", viewValue: "Solomon Islands"},
    { value: "SO", viewValue: "Somalia"},
    { value: "ZA", viewValue: "South Africa"},
    { value: "GS", viewValue: "South Georgia and the South Sandwich Islands"},
    { value: "SS", viewValue: "South Sudan"},
    { value: "ES", viewValue: "Spain"},
    { value: "LK", viewValue: "Sri Lanka"},
    { value: "SD", viewValue: "Sudan"},
    { value: "SR", viewValue: "Suriname"},
    { value: "SJ", viewValue: "Svalbard Jan Mayen"},
    { value: "SE", viewValue: "Sweden"},
    { value: "CH", viewValue: "Switzerland"},
    { value: "SY", viewValue: "Syria"},
    { value: "TW", viewValue: "Taiwan"},
    { value: "TJ", viewValue: "Tajikistan"},
    { value: "TZ", viewValue: "Tanzania"},
    { value: "CC", viewValue: "Territory of Cocos (Keeling) Islands"},
    { value: "TH", viewValue: "Thailand"},
    { value: "TL", viewValue: "Timor-Leste"},
    { value: "TG", viewValue: "Togo"},
    { value: "TK", viewValue: "Tokelau"},
    { value: "TO", viewValue: "Tonga"},
    { value: "TT", viewValue: "Trinidad and Tobago"},
    { value: "TN", viewValue: "Tunisia"},
    { value: "TR", viewValue: "Türkiye"},
    { value: "TM", viewValue: "Turkmenistan"},
    { value: "TC", viewValue: "Turks and Caicos Islands"},
    { value: "TV", viewValue: "Tuvalu"},
    { value: "UG", viewValue: "Uganda"},
    { value: "UA", viewValue: "Ukraine"},
    { value: "AE", viewValue: "United Arab Emirates"},
    { value: "GB", viewValue: "United Kingdom"},
    { value: "UM", viewValue: "United States Minor Outlying Islands"},
    { value: "US", viewValue: "United States of America"},
    { value: "UY", viewValue: "Uruguay"},
    { value: "UZ", viewValue: "Uzbekistan"},
    { value: "VU", viewValue: "Vanuatu"},
    { value: "VE", viewValue: "Venezuela"},
    { value: "VN", viewValue: "Viet Nam"},
    { value: "VG", viewValue: "Virgin Islands (British)"},
    { value: "VI", viewValue: "Virgin Islands (US)"},
    { value: "WF", viewValue: "Wallis and Futuna"},
    { value: "EH", viewValue: "Western Sahara"},
    { value: "YE", viewValue: "Yemen"},
    { value: "YU", viewValue: "Yugoslavia"},
    { value: "ZM", viewValue: "Zambia"},
    { value: "ZW", viewValue: "Zimbabwe"}
  ];

  public static readonly APPLICANT_TYPES: Array<ApplicantType> = [
    { abbreviation: ApplicantType.EMPLOYEE, label: 'Employee' },
    { abbreviation: ApplicantType.SPOUSE, label: 'Spouse' },
    { abbreviation: ApplicantType.CHILD, label: 'Child' },
  ];

  public static readonly SALARY_MULTIPLES: Array<SalaryMultiples> = [
    { abbreviation: '0.5', label: '0.5 x Annual Earnings' },
    { abbreviation: '1.0', label: '1 x Annual Earnings' },
    { abbreviation: '1.5', label: '1.5 x Annual Earnings' },
    { abbreviation: '2.0', label: '2 x Annual Earnings' },
    { abbreviation: '2.5', label: '2.5 x Annual Earnings' },
    { abbreviation: '3.0', label: '3 x Annual Earnings' },
    { abbreviation: '3.5', label: '3.5 x Annual Earnings' },
    { abbreviation: '4.0', label: '4 x Annual Earnings' },
    { abbreviation: '4.5', label: '4.5 x Annual Earnings' },
    { abbreviation: '5.0', label: '5 x Annual Earnings' },
    { abbreviation: '5.5', label: '5.5 x Annual Earnings' },
    { abbreviation: '6.0', label: '6 x Annual Earnings' },
    { abbreviation: '6.5', label: '6.5 x Annual Earnings' },
    { abbreviation: '7.0', label: '7 x Annual Earnings' },
    { abbreviation: '7.5', label: '7.5 x Annual Earnings' },
    { abbreviation: '8.0', label: '8 x Annual Earnings' },
  ];

  public static readonly SALARY_MULTIPLES_PRISM: Array<PrismDropDown> = [
    { value: '0.5', viewValue: '0.5 x Annual Earnings' },
    { value: '1.0', viewValue: '1 x Annual Earnings' },
    { value: '1.5', viewValue: '1.5 x Annual Earnings' },
    { value: '2.0', viewValue: '2 x Annual Earnings' },
    { value: '2.5', viewValue: '2.5 x Annual Earnings' },
    { value: '3.0', viewValue: '3 x Annual Earnings' },
    { value: '3.5', viewValue: '3.5 x Annual Earnings' },
    { value: '4.0', viewValue: '4 x Annual Earnings' },
    { value: '4.5', viewValue: '4.5 x Annual Earnings' },
    { value: '5.0', viewValue: '5 x Annual Earnings' },
    { value: '5.5', viewValue: '5.5 x Annual Earnings' },
    { value: '6.0', viewValue: '6 x Annual Earnings' },
    { value: '6.5', viewValue: '6.5 x Annual Earnings' },
    { value: '7.0', viewValue: '7 x Annual Earnings' },
    { value: '7.5', viewValue: '7.5 x Annual Earnings' },
    { value: '8.0', viewValue: '8 x Annual Earnings' },
  ];

  public static readonly MONTHS: Array<DropDown> = [
    { value: '01', label: 'January' },
    { value: '02', label: 'February' },
    { value: '03', label: 'March' },
    { value: '04', label: 'April' },
    { value: '05', label: 'May' },
    { value: '06', label: 'June' },
    { value: '07', label: 'July' },
    { value: '08', label: 'August' },
    { value: '09', label: 'September' },
    { value: '10', label: 'October' },
    { value: '11', label: 'November' },
    { value: '12', label: 'December' },
  ];

}


export const MHS_CONTROLS= {
  TEXTBOX: 'textbox',
  CHECKBOX: 'checkbox',
  YESNO: 'yesno',
  //DROPDOWN: 'dropdown',
  RADIOBUTTON: 'radiobutton',
  //RADIOBUTTON_GROUP: 'radiobuttongroup',
  DATEPICKER: 'datepicker'
} as const;

export const MHS_DATATYPES= {
  STRING: 'string',
  INTEGER: 'integer',
  BOOLEAN: 'boolean',
  DATE: 'date'
} as const;

export const MHS_VALIDATORS = {
  REQUIRED: 'required',
  MAX_LENGTH: 'maxlength',
  MIN_VALUE: 'min',
  MAX_VALUE: 'max',
  PATTERN: 'pattern',
  ONLY_IF_VISIBLE: "only-if-visible",
  COMPLETED_SUBQUESTION_COUNT: "completed-subquestion-count",
  MAX_DATE_OFFSET: "max-date-offset",
  MIN_DETAIL_REPEATS: "minDetailRepeats",
  MAX_DETAIL_REPEATS: "maxDetailRepeats"
} as const;


export const MHS_VALIDATOR_PATTERNS = {
  SSN: 'ssn',
  PHONE: 'phone',
  POSTAL_CODE: 'postal-code',
  EMAIL: 'email',
  NUMBER: 'number'
} as const;
